module.exports = __webpack_public_path__ + "img/07.226e72f0.png";